import IrrigationAreaPage from "./IrrigationAreaPage";

export default IrrigationAreaPage;
